import styled from '@emotion/styled'
import { css } from '@emotion/react'
import Col from 'antd/lib/col'

const deliveryZoneCss = css`
  max-width: 582px;

  .item {
    margin: 0;

    &.-hidden {
      display: none;
      visibility: hidden;
    }

    .row {
      min-height: 32px;

      .checkbox {
        cursor: default;
        pointer-events: none;
      }
    }

    .radio {
      margin-bottom: 8px;
    }

    .slider {
      margin: 0 20px 0 0;
      max-width: 480px;
    }
  }

  .map {
    margin: 0;
    position: relative;

    .tag {
      position: absolute;
      top: 10px;
      left: 10px;
      display: flex;
      padding: 1px 16px;
      border-radius: 4px;
      justify-content: center;
      align-items: center;
      background: #f6ffed;
      color: #4eb21c;
      font-size: 12px;
    }
  }

  & > .popup {
    padding: 14px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #1513a0;
    margin-bottom: 8px;
    background: #e9e8fc;
    border: 1px solid #1513a0;
    border-radius: 8px;

    &.-warning {
      color: #f38a19;
      background: #fff7e6;
      border-color: #f38a19;
    }
  }
`

export const DeliveryZoneContainer = styled.div`
  ${deliveryZoneCss}
`

export const DeliveryZoneSliderCol = styled(Col)`
  ${deliveryZoneCss}
`
